'use client';
import { LoadingSpinner } from './loading-spinner';
import { Dialog, DialogContent, DialogTitle } from './dialog';
export var LoadingDialog = function (_a) {
    var onClose = _a.onClose, text = _a.text;
    return (<Dialog open onOpenChange={onClose}>
      <DialogContent className="flex flex-col items-center justify-center gap-4 p-8" onPointerDownOutside={function (e) { return e.preventDefault(); }} onEscapeKeyDown={function (e) { return e.preventDefault(); }} showCloseButton={!!onClose}>
        <DialogTitle className="sr-only">Loading</DialogTitle>
        <LoadingSpinner size={54}/>
        {text && <div className="text-muted-foreground text-center">{text}</div>}
      </DialogContent>
    </Dialog>);
};
